/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_No_SpeechInputs */



/**
* | output |
* | --- |
* | "No speech was detected in this audio file." |
*
* @param {Embedding_Error_No_SpeechInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_no_speech = /** @type {((inputs?: Embedding_Error_No_SpeechInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_No_SpeechInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Audiodatei wurde keine Sprache erkannt.")
	return /** @type {LocalizedString} */ ("No speech was detected in this audio file.")
});